// Active server id for the `X-Server-Id` request header (multi-server,
// OSPROD-199). Held here — outside React and the Zustand stores — so the
// axios interceptor in services/api.ts can read it without a circular import
// with serverStore (which imports serverApi from api.ts). Backed by
// localStorage so the active server survives a page reload. Distinct from
// user.settings.lastActiveServerId (DB-persisted, drives the useActiveServer
// UI fallback chain) — this one only feeds the request header.
const KEY = 'activeServerId'

let current: string | null = (() => {
  try {
    return localStorage.getItem(KEY)
  } catch {
    return null
  }
})()

export function setRequestActiveServer(id: string | null): void {
  current = id
  try {
    if (id) localStorage.setItem(KEY, id)
    else localStorage.removeItem(KEY)
  } catch {
    // private-mode / storage disabled — the in-memory value still works
  }
}

export function getRequestActiveServer(): string | null {
  return current
}
